













// Copyright © 2021 Move Closer

import { defineComponent } from '@vue/composition-api'

import { DashmixBadge, DashmixButton, DashmixIcon } from '../../atoms'

import { actionBadgeProps } from './ActionBadge.hook'

/**
 * @author Olga Milczek <olga.milczek@movecloser.pl>
 */
export const DashmixActionBadge = defineComponent({
  name: 'DashmixActionBadge',
  components: { DashmixButton, DashmixBadge, DashmixIcon },
  props: actionBadgeProps,
  emits: ['clicked']
})

export default DashmixActionBadge
